import {EmployeeBonusPoints} from "../shared/EmployeeBonusPoints.js";
import {BasketAndCheckoutTracking} from "../shared/BasketAndCheckoutTracking";

window.o_global.eventQBus.onModuleLoaded(
  'ft1.order-core.basket',
  ['ft1.order-core.common-public', 'ft1.order-core.common-private'],
  () => { /*🤫*/

    var o_order = window.o_order || {};
    o_order.exactag = o_order.exactag || {};

    o_order.basket = o_order.basket || {};
    o_order.basket.view = o_order.basket.view || o_order.basket.viewBuilder(window);
    o_order.basket.service = o_order.basket.service || o_order.basket.serverBoundaryBuilder();
    o_order.basket.presenter = o_order.basket.presenter || o_order.basket.presenterBuilder(window, o_order.basket.view, o_order.basket.service);
    if (!o_order.basket.initialized) {
      o_order.basket.presenter.init();
      o_order.basket.initialized = true;
    }

    o_order.services.view = o_order.services.view || o_order.services.viewBuilder(window);
    o_order.services.presenter = o_order.services.presenter || o_order.services.presenterBuilder(o_order.services.view, o_order.basket.view, o_order.services.serverBoundaryBuilder, o_order.globals.CONTEXT.BASKET);
    if (!o_order.services.presenter.initialized) {
      o_order.services.presenter.init();
      o_order.services.presenter.initialized = true;
    }

    try {
      window.lhotse.exactag.register('orderBasket', o_order.performancemarketing.data.buildBasketDataFactory(window.lhotse.exactag.data));
    } catch (e) {
      if (o_global.debug.status().activated) {
        console.error(e);
      }
    }

    EmployeeBonusPoints.initialize(o_order.settings.service)
    new BasketAndCheckoutTracking(window.o_order.tracking).initialize();
  }
);
